import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const SHORTCUTS: Array<{ keys: string[]; description: string }> = [
  { keys: ["/"], description: "Focus global search" },
  { keys: ["Esc"], description: "Close dialogs and the doctor details drawer" },
  { keys: ["Ctrl / ⌘", "Shift", "R"], description: "Refresh pending doctors" },
  { keys: ["?"], description: "Open this shortcuts help" },
];

export function ShortcutHelpDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Keyboard shortcuts</DialogTitle>
          <DialogDescription>Work through reviews without leaving the keyboard.</DialogDescription>
        </DialogHeader>
        <ul className="mt-2 divide-y divide-border">
          {SHORTCUTS.map((shortcut) => (
            <li key={shortcut.description} className="flex items-center justify-between gap-4 py-3">
              <span className="text-sm text-muted-foreground">{shortcut.description}</span>
              <span className="flex shrink-0 items-center gap-1">
                {shortcut.keys.map((key) => (
                  <kbd
                    key={key}
                    className="rounded-md border border-border bg-muted px-1.5 py-0.5 font-mono text-[0.7rem] font-semibold text-foreground"
                  >
                    {key}
                  </kbd>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
